export const REGEX = {
  ALPHABET: /^[A-Za-z\s]+$/,

  ALPHANUMERIC:
    /^[a-zA-Z0-9\s&.,'-]+$/,
  
  TEXTAREA: 
    /^[\p{L}\p{N}\p{M}\p{P}\p{S}\p{Zs}\r\n\t]*$/u,

  EMAIL:
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/,

  PASSWORD:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).+$/,

  NUMBER:
    /^\d+$/,

  DECIMAL:
    /^\d+(\.\d{1,2})?$/,

  PHONE:
    /^[6-9]\d{9}$/,

  URL:
    /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/
};